/**
 * Import / Export configuration strings.
 *
 * Help text (h_) was migrated from the inline renderHelpLabel JSX in
 * src/Configuration/ImportExport/Export/ExportCard.tsx and
 * src/Configuration/ImportExport/Import/ConfigureImport.tsx — verify against the
 * implementation. The import-source entries take params (connector name + doc links)
 * because the help is specific to the selected connector. External links open in a
 * new tab via HelpMessage's sanitize hook.
 */
export default {
    d_format: 'Format',
    h_format: '<div>What format would you like for your output files?<br/>Ask your vendor which format they prefer.<ul><li><strong>CSV</strong> stands for Comma Separated Values, and is a simple export format supported by nearly all applications</li><li><strong>JSON</strong> stands for JavaScript Object Notation, and is used by many of the more recent web applications</li></ul></div>',

    d_apiKey: 'API Key',
    h_apiKey: (params: {connectorName?: string, apiDocLink?: string}) =>
        `<div>${params?.connectorName} requires an API Key in order to access your data. This is a much safer method than passing your login credentials to another program!</div><div>To find out how to generate an API key for use with Outlaw Practice, visit <a href="${params?.apiDocLink}">their documentation</a>, then paste the generated API Key here.</div>`,

    d_uploadFiles: 'Upload Files',
    h_uploadFiles: (params: {connectorName?: string, filesDocLink?: string}) =>
        `<div>To find out how to export files from ${params?.connectorName}, visit <a href="${params?.filesDocLink}">their documentation</a>.</div><div>If the download created one large .zip file, ensure that the zip file has been unzipped into a directory.</div><div>Click on Use My Files and select all of the files in that directory.</div><div>If these files are very old, there may be issues with import. If that is the case, contact&nbsp;<a href="mailto:support@outlawpractice.com">Support</a> and we will help you do your import.</div>`,

    d_apiFiles: 'Remote Files Loaded',
    h_apiFiles: 'The following files will be fetched from the remote server',

    d_localFiles: 'Local Files Loaded',
    h_localFiles: 'The following files will be uploaded',
};
